(() => {
  function getTabIndexForKey(key, currentIndex, tabCount) {
    if (tabCount < 2) return currentIndex;

    switch (key) {
      case 'ArrowRight':
        return (currentIndex + 1) % tabCount;
      case 'ArrowLeft':
        return (currentIndex - 1 + tabCount) % tabCount;
      case 'Home':
        return 0;
      case 'End':
        return tabCount - 1;
      default:
        return currentIndex;
    }
  }

  function getEmptyTabElements(emptyElement) {
    return {
      tabs: Array.from(emptyElement.querySelectorAll('[data-kl-cart-empty-tab]')),
      panels: Array.from(emptyElement.querySelectorAll('[data-kl-cart-empty-panel]')),
    };
  }

  function activateEmptyPanel(panel) {
    const template = panel.querySelector(':scope > template[data-kl-cart-empty-template]');

    if (!template) return;

    const fragment = template.content.cloneNode(true);

    template.replaceWith(fragment);

    try {
      document.dispatchEvent(new CustomEvent('kl:content:added', { detail: { root: panel } }));
    } catch (error) {
      console.debug('kl-cart-drawer-empty: could not announce the added panel content', { error });
    }
  }

  function updateEmptySelection(tabs, panels, selectedIndex, canMoveFocus) {
    const selectedTab = tabs[selectedIndex];

    if (!selectedTab) return;

    try {
      const selectedSlot = selectedTab.dataset.klCartEmptyTab;

      tabs.forEach((tab, index) => {
        const isSelected = index === selectedIndex;

        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isSelected = panel.dataset.klCartEmptyPanel === selectedSlot;

        if (isSelected) activateEmptyPanel(panel);

        panel.hidden = !isSelected;
      });

      if (canMoveFocus) selectedTab.focus();
    } catch (error) {
      console.debug('kl-cart-drawer-empty: could not switch collection', { selectedIndex, error });
    }
  }

  function initCartDrawerEmpty() {
    document.querySelectorAll('[data-kl-cart-empty]').forEach((emptyElement) => {
      const { tabs, panels } = getEmptyTabElements(emptyElement);

      if (tabs.length < 2 || !panels.length) return;

      const renderedIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');

      updateEmptySelection(tabs, panels, Math.max(0, renderedIndex), false);
    });
  }

  document.addEventListener('click', (event) => {
    const tabElement = event.target.closest('[data-kl-cart-empty-tab]');

    if (!tabElement) return;

    const emptyElement = tabElement.closest('[data-kl-cart-empty]');

    if (!emptyElement) return;

    const { tabs, panels } = getEmptyTabElements(emptyElement);

    updateEmptySelection(tabs, panels, tabs.indexOf(tabElement), false);
  });

  document.addEventListener('keydown', (event) => {
    const tabElement = event.target.closest('[data-kl-cart-empty-tab]');

    if (!tabElement) return;

    const emptyElement = tabElement.closest('[data-kl-cart-empty]');

    if (!emptyElement) return;

    const { tabs, panels } = getEmptyTabElements(emptyElement);
    const currentIndex = tabs.indexOf(tabElement);
    const nextIndex = getTabIndexForKey(event.key, currentIndex, tabs.length);

    if (nextIndex === currentIndex) return;

    event.preventDefault();
    updateEmptySelection(tabs, panels, nextIndex, true);
  });

  initCartDrawerEmpty();

  document.querySelectorAll('[data-kl-cart-drawer], [data-kl-cart-page]').forEach((cartRootElement) => {
    new MutationObserver(() => initCartDrawerEmpty()).observe(cartRootElement, {
      childList: true,
      subtree: true,
    });
  });

  document.addEventListener('shopify:section:load', () => initCartDrawerEmpty());
})();
